class ProductGridView extends HTMLElement {
    oneColsClassName = 'grid--1-col-tablet-down'
    twoColsClassName = 'grid--2-col-tablet-down'

    constructor() {
        super()
        this.buttons = this.querySelectorAll('button')
        this.productGrid = document.querySelector('#ProductGridContainer ul#product-grid') || document.querySelector('#ProductGridContainer ul.product-grid')
    }

    connectedCallback() {
        this.buttons.forEach(button => {
            button.addEventListener('click', this.toggleView.bind(this, button, parseInt(button.dataset.gridView)))
        })
    }

    getActiveView() {
        return Array.from(this.buttons).find(button => button.classList.contains('active')).dataset.gridView || null
    }

    updatePaginationHyperlinks(column) {
        const paginationLinks = document.querySelectorAll('.pagination-wrapper  a');
        paginationLinks.forEach(link => {
            if (!link.href)
                return
            const url = new URL(link.href);
            if (column === 1)
                url.searchParams.set('view', 'one-column');
            else if (column === 2)
                url.searchParams.delete('view');
            link.href = url.toString();
        });
    }


    /**
     * 
     * @param {HTMLButtonElement} btn 
     * @param {1 | 2} viewPerRow 
     */
    toggleView(btn, column = 2) {
        // New code to reload the page with updated URL parameter
        // ----------------------------------------------------------
        if (typeof window.luxoPublishEvent === 'function') {
            window.luxoPublishEvent('grid_view_changed', { columns: column });
        }
        const url = new URL(window.location.href);

        // Only change the `view` parameter
        if (column === 2) {
            // Back to default grid: remove `view`
            url.searchParams.delete('view');
        } else if (column === 1) {
            // One-column grid: set `view`
            url.searchParams.set('view', 'one-column');
        }

        // Build a nice relative URL (keeps page, sort_by, filters, etc.)
        const qs = url.searchParams.toString();
        const finalUrl = url.pathname + (qs ? `?${qs}` : '') + url.hash;

        window.location.assign(finalUrl);

        // Old code for toggling without page reload - Bring back if new changes don't improve INP metric
        // Note: If bringing back, also bring back code in product-card.js in function addEventListeners
        // ----------------------------------------------------------------------------------------------------------
        // const event = new CustomEvent('toggleGridView', {
        //     detail: { column: column }
        // });
        // window.dispatchEvent(event);
        // if (typeof gtag === 'function') {
        //     gtag('event', 'user_interaction', {
        //         'event_category': 'Toggle Grid View',
        //         'event_label': `Grid View: ${column}`,
        //         'event_action': 'Changed',
        //         'event_value': column
        //     });
        // }
        // if (!this.productGrid || this.getActiveView() == column)
        //     return
        // if (column == 1) {
        //     this.productGrid.classList.add(this.oneColsClassName)
        //     this.productGrid.classList.remove(this.twoColsClassName)
        // }
        // else {
        //     this.productGrid.classList.add(this.twoColsClassName)
        //     this.productGrid.classList.remove(this.oneColsClassName)
        // }
        // btn.classList.add('active')
        // btn.setAttribute('aria-pressed', 'true')
        // const otherBtn = Array.from(this.buttons).find(b => b !== btn)
        // if (otherBtn) {
        //     otherBtn.classList.remove('active')
        //     otherBtn.setAttribute('aria-pressed', 'false')
        // }
        // this.updatePaginationHyperlinks(column)
    }
}

customElements.define('product-grid-view', ProductGridView)
